var _path, _path2, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46468 53.0648V19.8382L26.7771 6.87917C27.294 6.5649 27.9451 6.57421 28.4528 6.90313L31.0235 2.93556L28.4528 6.90313L48.2805 19.75V53.0648C48.2805 53.9351 47.575 54.6407 46.7047 54.6407H7.04055C6.17022 54.6407 5.46468 53.9351 5.46468 53.0648Z",
    stroke: "white",
    strokeWidth: 9.45517
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11417 9.4569C9.11417 7.71625 10.5252 6.30518 12.2659 6.30518H42.7954C44.536 6.30518 45.9471 7.71625 45.9471 9.4569V14.0307C45.9471 15.1958 45.3043 16.2658 44.2758 16.8131L29.1189 24.8773C28.1986 25.367 27.0957 25.3699 26.1728 24.8851L10.8002 16.8095C9.76346 16.2649 9.11417 15.1904 9.11417 14.0194V9.4569Z",
    fill: "#D2E0F4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.691,
    y1: 12.8055,
    x2: 38.0402,
    y2: 12.932,
    stroke: "#5F2B20",
    strokeWidth: 2.36379,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 15.691,
    y1: 16.7273,
    x2: 38.0402,
    y2: 16.8537,
    stroke: "#5F2B20",
    strokeWidth: 2.36379,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contactIcon.1b509c903c1036ffae0389f9412b444e.svg";
export { ForwardRef as ReactComponent };